<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                     <v-btn dark icon title="Back to cut off list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="attendance" :pageId="helpPageId" color="white"></help-link>
                    <v-chip v-if="frozenPeriod" label small class="warning" dark title="This period is already Frozen. You will not be able to change this record.">Frozen</v-chip>
                    <v-chip v-if="closedPeriod" label small class="grey darken-2" dark title="This period is already Closed. You will not be able to change this record.">Closed</v-chip>
                    
                    <v-btn v-if="hasTeamAddRights" fab small title="Add Personal Time Off" @click="showAddTimeOff" class="primary" v-show="!disableConditions">
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-toolbar>
            </v-card>
            <v-card class="elevation-1 mt-5">
                <v-toolbar flat height="45px">
                    <v-text-field v-model="search" append-icon="search" label="Search name" class="mb-15" single-line hide-details clearable></v-text-field>
                    <v-spacer></v-spacer>
                    <b>{{cutOffPeriod}}</b>                    
                </v-toolbar>
                <v-data-table
                    :headers="isMobile?headers_mobile:headers"
                    :items="timeoff_details_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" class="clickable" title="Click to view timesheet for this period">
                            <td>
                                <v-chip class="user-chip-container">
                                    <v-avatar>
                                        <v-img :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                    </v-avatar>
                                    {{props.item.firstName}} {{props.item.lastName}}
                                </v-chip>
                            </td>
                            <td>
                                <span v-if="isMobile">{{ props.item.transDate | moment('MMM D') }}</span>
                                <span v-else>{{ props.item.transDate | moment('YYYY-MM-DD (ddd)') }}</span>
                            </td>
                            <td v-if="!isMobile">{{ props.item.leaveName }}</td>
                            <td v-if="!isMobile">{{ props.item.hours }}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>

        <v-dialog v-model="dialogPTO" width="500" persistent>   
            <add-edit-timeoff ref="addEditTimeoffRef" :enableDateRange="true" @send="getTimeOff()" :dialogPTO.sync="dialogPTO"></add-edit-timeoff>
        </v-dialog>
    </v-layout>  
</template>

<script>

import { syncTeamContext } from '@/helpers/team-selector'
import timeOffApi from '@/api/timeoffs'
import commonfn from '@/common/functions'
import awsS3Helper from '@/helpers/aws-s3'
import rowsPerPageItems from '@/constants/rows-per-page'
import AppPageID from '@/constants/app_page_ids'
import { getCutoffCoverageDescription } from '@/helpers/cutoff-format'
import { getSort, getRowsPerPage, getSearchKeyword, updateRowsPerPage, updateSort, updateSearchKeyword } from '@/helpers/user-prefs'
import { hasTeamAddRights } from '@/helpers/myteams-permissions'

export default {     
    name: 'TeamTimeOff',
    metaInfo: {
        title: 'Team TimeOff',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Team TimeOff' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'add-edit-timeoff': () => import('@/components/TimeOff/AddEditTimeOff'),
    },   
    props: ['teamId', 'pageKey'],
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)

        return {
            commonfn,
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            search: getSearchKeyword(routeName),
            error: false,
            errorMessage: '',
            loading: false,
            dialogPTO: false,
            loading_download: false,
            headers: [
                {text: 'Employee',align: 'left',value: 'lastName', width:'15%', sortable:true},
                {text: 'Date',align: 'left',value: 'transDate', width:'10%', sortable:true},
                {text: 'Leave Type',align: 'left',value: 'leaveName', width:'20%',sortable:true},
                {text: 'Hours',align: 'left',value: 'hours', width:'5%',sortable:true},
                {text: 'Status',align: 'left',value: 'status', width:'10%',sortable:true},
            ],
            headers_mobile: [
                {text: 'Employee',align: 'left',value: 'lastName', width:'15%', sortable:true},
                {text: 'Date',align: 'left',value: 'transDate', width:'10%', sortable:true},
                {text: 'Status',align: 'left',value: 'status', width:'10%',sortable:true},
            ],
            loading_download: false,
            cutoff_details: null,
            timeoff_details: [],
        }
    },
    methods: {  
        showAddTimeOff() {
            var data = {
                mode: 'Add',
                cutoff: this.cutoff_details,
                isRequestForOtherUser: true,
                selectedCutOffId: this.selectedCutOffId,
                workShift: ''
            }
            this.$refs.addEditTimeoffRef.setParams(data)
            this.dialogPTO = true
        },
        viewDetails(data) {
            this.$router.push(`/myteam/timeoff/details/${data.timeOffId}`)
        }, 
        async getTimeOff() {
            try {
                this.loading = true
                const response = await timeOffApi.getByCutoffByTeam(this.selectedCutOffId, this.pageKey, this.teamId)
                if (response && response.status == 200) {
                    this.cutoff_details = response.data.cutoffItem
                    this.timeoff_details = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        teamChangeHandler(data) {
            if (data === 'team-changed-handler') {
                this.getTimeOff()
            }
        }
    },
    async mounted() {
        await syncTeamContext()
    },
    created() {
        this.getTimeOff()

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Team Time Offs',
            isTeamPage: true
        })

        // Listen for the change event
        this.$root.$on('team-changed', this.teamChangeHandler)
    },
    beforeDestroy() {
        this.$root.$off('team-changed', this.teamChangeHandler)
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        hasTeamAddRights() {
            return hasTeamAddRights(AppPageID.TeamTimeOff)
        },
        selectedCutOffId() {
            return this.$route.params.cutOffId
        },
        cutOffPeriod() {
            if (this.cutoff_details)
                return getCutoffCoverageDescription(this.cutoff_details.cutoffStart, this.cutoff_details.cutoffEnd)
        },
        timeoff_details_filtered() {
            var temp = this.timeoff_details

            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return ( 
                            item.firstName.toLowerCase().includes(this.search.toLowerCase()) || 
                            item.lastName.toLowerCase().includes(this.search.toLowerCase())
                        )
                })
            }
            return temp
        },
        helpPageId() {
            return 'timeoff-review-team'
        },
        frozenPeriod() {
            if (this.cutoff_details)
                return this.cutoff_details.status==commonfn.getStatusCode('Frozen')
        },
        closedPeriod() {
            if (this.cutoff_details)
                return this.cutoff_details.status==commonfn.getStatusCode('Closed')
        },
        disableConditions() {
            return this.loading || this.frozenPeriod || this.closedPeriod
        },
    }
}
</script>